import { render } from "./IdeasDrawer.vue?vue&type=template&id=5e775840&scoped=true"
import script from "./IdeasDrawer.vue?vue&type=script&lang=js"
export * from "./IdeasDrawer.vue?vue&type=script&lang=js"

import "./IdeasDrawer.vue?vue&type=style&index=0&id=5e775840&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5e775840"]])

export default __exports__